var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"notification mb-5 mr-5",attrs:{"border":"top","colored-border":"","color":"green","type":"info","elevation":"2","value":_vm.alert,"transition":"scale-transition"}},[_vm._v(" "+_vm._s(_vm.notificationText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }